import { Auth } from "aws-amplify";
import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { getCurrentLocalDateTime } from "../../../../utils/getLocalDateTime";
import API from "../../api/api.main";
import { getLastItem } from "../../utils/leasing.u";
import { Radio } from "antd";

function ManageMain() {
  const { user } = useSelector((state) => state.initializeApp);

  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [countRecord, setCountRecord] = useState(0);
  const [min, setMin] = useState("");
  const [max, setMax] = useState("");
  const [buroDate, setBuroDate] = useState("");
  const [selectRadio, setSelectRadio] = useState("")

  const fetchLeasingAll = async () => {
    try {
      setLoading(true);
      let count = 0;
      let lastItem = null;
      let leasings = [];

      const minFormat = getCurrentLocalDateTime(new Date(min));
      const maxFormat = getCurrentLocalDateTime(new Date(max));

      do {
        const data = await API.get("MoneyHubAdmin", `/leasing/loan`, {
          queryStringParameters: {
            loan_status: "ACTIVE",
            min: minFormat.isoDateTime,
            max: maxFormat.isoDateTime,
            ExclusiveStartKey: getLastItem(lastItem),
            Limit: 50,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });

        leasings = [...leasings, ...data?.leasing_loans];

        lastItem = data?.lastItem;
        count = leasings.length;
        setCountRecord((prev) => {
          return {
            ...prev,
            [countRecord]: count,
          };
        });
      } while (lastItem !== null);
      setLoans(leasings);
    } catch (error) {
      console.log("fetch leasing request error", error);
    } finally {
      setLoading(false);
    }
  };

  const onChangeRadio = (e) => {
    setSelectRadio(e?.target?.value)
  }

  return (
    <div>
      <div className="flex items-center">
        <Radio.Group onChange={onChangeRadio} value={selectRadio}>
          <Radio value={1}>Multiple</Radio>
          <Radio value={2}>Single</Radio>
        </Radio.Group>
      </div>
    </div>
  );
}

export default ManageMain;
